import React, { useState } from "react";
import "./timeSlider.css";
import { useSharedState } from "../../context/formsContext";
import { getProperty } from "../../utils/apiResponseHelper";

const TimeSlider = ({ percent, index, getQuestionFromTimeBar, isGcse }) => {
  const { liveCurrentQuizQuestions } = useSharedState();
  const [hover, setHover] = useState(false);

  const questionNumber = index + 1;

  const getBackgroundColor = (isHovering) => {
    if (liveCurrentQuizQuestions && liveCurrentQuizQuestions[index]) {
      const questionItem = liveCurrentQuizQuestions[index];
      const questionAttempted = getProperty(questionItem, 'questionAttempted') || getProperty(questionItem, 'QuestionAttempted') || questionItem?.QuestionAttempted || questionItem?.questionAttempted || '';
      
      if (questionAttempted === "Y") {
        return isGcse
          ? isHovering
            ? "#3c9153"
            : "#50c76f"
          : isHovering
          ? "#8abb4d"
          : "#9fd066";
      } else if (questionAttempted === "P") {
        return isGcse
          ? isHovering
            ? "#c79e23"
            : "#ffca2c"
          : isHovering
          ? "#e57c2b"
          : "#fd943d";
      }
    }
    return "#fff";
  };

  return (
    <div className="w-full timeLine-container">
      <div
        className="timeSlider-container"
        onClick={() => getQuestionFromTimeBar(index)}
        style={{ flex: `0 0 ${percent}%` }}
      >
        <div
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          className={
            isGcse
              ? hover
                ? "timeLineHover-gcse drop-shadow cursor-pointer"
                : "timeLine-gcse drop-shadow"
              : hover
              ? "timeLineHover drop-shadow cursor-pointer"
              : "timeLine-gcse drop-shadow"
          }
          style={{ width: "100%", backgroundColor: getBackgroundColor(hover) }}
        >
          <div className="flex justify-center">
            <p className="font-bold">{`Q${questionNumber}`}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeSlider;
